function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-container">
                <p className="footer-text">
                    © Cris Gym 2020 - {currentYear}
                </p>

                <a
                    href="https://www.termsfeed.com/live/6dddbfc5-f81f-4870-a93f-3d7de97a97be"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-link"
                >
                    Politica de prelucrare a datelor
                </a>
            </div>
        </footer>
    );
}

export default Footer;